<div *ngIf="subscriptionPrice" class="subscription-paywall">
  <div class="flex subscription-paywall_main items-center">
    <img class="subscription-paywall_image" [src]="creatorImg" alt="creator-subscription" />
    <div class="subscription-paywall_info">
      <p class="subscription-paywall_info__heading">Want to do more with me?</p>
      <p class="subscription-paywall_info__subheading">
        Subscribe for just {{ subscriptionPrice / 100 | currency }}
        <!--        Hidden, because currently we don't support subscription with tokens.-->
        <!--        <span class="subscription-paywall_tokens">-->
        <!--          <img src="/assets/icons/token-badge.svg" alt="token" />-->
        <!--          {{ subscriptionPrice / 100 }}-->
        <!--        </span>-->
        <!--        /month. Risk free, cancel anytime.-->
      </p>
      <p class="subscription-paywall_info__plan">24/7 access • Risk free • Cancel anytime</p>
    </div>
  </div>
  <stxt-button
    class="subscription-paywall_btn"
    [buttonConfig]="subscribeBtn"
    (click)="subscribeEvent.emit()"
    (keydown.enter)="subscribeEvent.emit()"
  >
    {{ subscribeBtn.text }}
  </stxt-button>
</div>
